import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface GlassCardProps {
  children: ReactNode;
  className?: string;
  /** Passed through for `role="alert"` and friends. */
  role?: string;
}

/**
 * The frosted panel every dark surface is built from.
 *
 * The material was being retyped at each call site, and had already drifted:
 * the toasts use rgba(38,38,41,0.72) because they sit over content, while
 * panels that occupy layout use the lighter 0.6, and one card had neither.
 * This is the 0.6 panel form, defined once.
 *
 * The two-part shadow is deliberate: a wide soft one gives the panel height
 * off the background, and a tight dark one keeps the edge from dissolving
 * into a dark surface behind it. Dropping either makes it look flat or
 * makes it look like it is floating with no weight.
 */
export function GlassCard({ children, className, role }: GlassCardProps) {
  return (
    <div role={role} className={cn('glass-card', className)}>
      {children}
    </div>
  );
}
